function calculateWornGirth() {
    const sleeveCirc = parseFloat(document.getElementById('sleeveCirc').value);
    const penisCirc = parseFloat(document.getElementById('penisCirc').value);
    const internalDiamRaw = document.getElementById('internalDiam').value;

    if (isNaN(sleeveCirc) || isNaN(penisCirc) || internalDiamRaw === "") {
        alert('Please enter valid numbers in all fields.');
        return;
    }

    const internalDiam = parseFloat(internalDiamRaw);

    // Convert internal diameter to circumference
    const interiorCirc = internalDiam * Math.PI;

    // Apply worn girth formula
    const wornGirth = (sleeveCirc - interiorCirc + penisCirc) * 0.9;

    document.getElementById('result').innerText = `Estimated Worn Girth: ${wornGirth.toFixed(2)} inches`;
}

// Make sure event listener is properly connected
document.getElementById('calculateBtn').addEventListener('click', calculateWornGirth);